import qs from 'qs';

import { XDP_PRODUCT_TYPES } from 'bundles/search-common/constants/entityTypes';
import type { SearchProductHit } from 'bundles/search-common/providers/searchTypes';
import getXDPPageLink from 'bundles/unified-description-page-common/utils/getXDPPageLink';

const getProductPageUrlFromHit = ({
  hit,
  shouldUseSubfolderLinksForXDP,
  subfolderLocaleCode,
  queryParams,
}: {
  hit: SearchProductHit;
  shouldUseSubfolderLinksForXDP: boolean;
  subfolderLocaleCode?: string;
  queryParams?: Record<string, string | string[] | undefined>;
}) => {
  let url = hit?.url ?? undefined;
  if (hit?.productType && hit?.url && XDP_PRODUCT_TYPES.includes(hit.productType) && shouldUseSubfolderLinksForXDP) {
    url = getXDPPageLink({ productPageUrlPath: hit.url, subfolderLocaleCode });
  }

  if (queryParams && url) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${qs.stringify(queryParams)}`;
  }

  return url;
};

export default getProductPageUrlFromHit;
